import { ADDBOOKS, DELETEBOOK, EDITBOOK, LOADBOOKS } from "./actionTypes";
import initialState from "./initialState";

const getMaxId = (state) => {
  return state.reduce((prevId, currentElement) => {
    return Math.max(prevId, currentElement.id);
  }, -1);
};

const booksReducer = (state = initialState, action) => {
  switch (action.type) {
    case LOADBOOKS:
      return action.payload;

    case ADDBOOKS:
      return [
        ...state,
        {
          id: getMaxId(state) + 1,
          name: action.payload.name,
          author: action.payload.author,
          thumbnail: action.payload.thumbnail,
          price: action.payload.price,
          rating: action.payload.rating,
          featured: action.payload.featured,
        },
      ];
    case EDITBOOK:
      return state.map((book) => {
        if (book.id === action.payload.id) {
          return {
            id: action.payload.id,
            name: action.payload.name,
            author: action.payload.author,
            thumbnail: action.payload.thumbnail,
            price: action.payload.price,
            rating: action.payload.rating,
            featured: action.payload.featured,
          };
        } else {
          return { ...book };
        }
      });
    case DELETEBOOK:
      return state.filter((book) => {
        return book.id !== action.payload;
      });

    default:
      return [...state];
  }
};

export default booksReducer;
